import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { iconClassName } from '../icon.utils';
import type { BaseIconProps } from '../icon.utils';
import clsx from 'clsx';
import { extractProps } from '@/utils/vanilla-extract-props';
import { color as colorStyle } from '@/css/typography.css';
import PlumaBox from '../../box/ember/index';
import type { BoxSignature } from '../../box/ember/index';
import { sprinkles } from '@/css/sprinkles.css';
export interface IconSignature {
    Element: BoxSignature<'div'>['Element'];
    Args: BoxSignature<'div'>['Args'] & BaseIconProps;
    Blocks: {
        default: [];
    };
}
export default class Icon extends Component<IconSignature> {
    get className() {
        const { color: color1, size: size1, isInline: isInline1, inlineAlignment: inlineAlignment1, ...restArgs1 } = this.args;
        const { sprinkleProps: sprinkleProps1 } = extractProps(restArgs1);
        return clsx(iconClassName({
            size: size1,
            isInline: isInline1,
            inlineAlignment: inlineAlignment1
        }), color1 != null ? colorStyle[color1] : null, sprinkles(sprinkleProps1));
    }
    get hasLabel() {
        const { label: label1 } = this.args;
        return label1 != null && label1 !== '';
    }
    // prettier-ignore
    static{
        template(`<PlumaBox
				@as='svg'
				class={{this.className}}
				xmlns='http://www.w3.org/2000/svg'
				aria-hidden={{if this.hasLabel undefined 'true'}}
				aria-label={{if this.hasLabel @label undefined}}
				{{! @glint-expect-error }}
				...attributes
			><use xlink:href='#{{@name}}'></use></PlumaBox>`, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
